import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ArchiveWorkOrdersModalState {
  isArchiveWorkOrdersModalOpened: boolean;
}

interface ToggleViewPayload {
  isArchiveWorkOrdersModalOpened: boolean;
}

export const initialState: ArchiveWorkOrdersModalState = {
  isArchiveWorkOrdersModalOpened: false
};

const archiveWorkOrdersModalSlice = createSlice({
  name: 'archiveWorkOrdersModal',
  initialState,
  reducers: {
    archiveModalToggleView(state, action: PayloadAction<ToggleViewPayload>) {
      state.isArchiveWorkOrdersModalOpened = action.payload.isArchiveWorkOrdersModalOpened;
    }
  }
});

export const {
  archiveModalToggleView
} = archiveWorkOrdersModalSlice.actions;

export default archiveWorkOrdersModalSlice.reducer;
